/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductChangeInverterList } from '../models/PaginatedProductChangeInverterList';
import type { PatchedProductChangeInverter } from '../models/PatchedProductChangeInverter';
import type { ProductChangeInverter } from '../models/ProductChangeInverter';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsChangeInverterService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductChangeInverterList
     * @throws ApiError
     */
    public productsChangeInverterList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductChangeInverterList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-change-inverter/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductChangeInverter
     * @throws ApiError
     */
    public productsChangeInverterCreate({
        requestBody,
    }: {
        requestBody: ProductChangeInverter,
    }): CancelablePromise<ProductChangeInverter> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-change-inverter/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductChangeInverter
     * @throws ApiError
     */
    public productsChangeInverterRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product change inverter.
         */
        id: number,
    }): CancelablePromise<ProductChangeInverter> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-change-inverter/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductChangeInverter
     * @throws ApiError
     */
    public productsChangeInverterUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product change inverter.
         */
        id: number,
        requestBody: ProductChangeInverter,
    }): CancelablePromise<ProductChangeInverter> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-change-inverter/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductChangeInverter
     * @throws ApiError
     */
    public productsChangeInverterPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product change inverter.
         */
        id: number,
        requestBody?: PatchedProductChangeInverter,
    }): CancelablePromise<ProductChangeInverter> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-change-inverter/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsChangeInverterDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product change inverter.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-change-inverter/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
